var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-gis",on:{"click":_vm.toGisPage}},[_c('img',{attrs:{"src":require("@/assets/img/btn-gis.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }